<div class="flex-column flex-fill">
  <ag-grid-angular style="height: 100%;" class="ag-theme-balham ag-wrap-header-text ag-highlighted-group-headers"
    [gridOptions]="gridOptions" [groupDefaultExpanded]="0"
    (gridReady)="onGridReady($event)"
    (gridSizeChanged)="onGridSizeChanged($event)">
  </ag-grid-angular>
</div>